/* eslint-disable id-length */
/* eslint-disable new-cap */
/* eslint-disable no-unused-vars */
import baseEvents from '../../base/config/baseEvents';

export const FILTER_OPTIONS = {
    STOPS: {
        ALL: 7,
    },
};

export default function AtcFlightsFactory(
    $filter,
    $rootScope,
    atcFlightSearchParams,
    atcApiService,
    userService,
    atcFlightsService,
    sessionService,
    l10nService,
    loginFactory,
) {
    'ngInject';

    const _flights = {};
    const _params = {};

    return function(module) {

        if (!_flights[module]) {
            _flights[module] = {};
        }
        let flights = _flights[module];

        if (!_params[module]) {
            _params[module] = new atcFlightSearchParams(module); // eslint-disable-line
        }
        const params = _params[module];

        // const regionalSettings = userService.getRegionalSettings();
        // const defaultFilters = {};
        // let comparisonFilter = null;

        const labels = {
            items: 'Flight(s)',
            findItems: 'Find flights',
            operators: 'Airlines',
            stations: 'Airports',
            stoppage: {
                title: 'Stops',
                keys: {
                    1: 'Non Stop',
                    2: '1 Stop',
                    [FILTER_OPTIONS.STOPS.ALL]: 'All',
                },
            },
        };

        const BOOK_MONTHS_ADVANCE = 11;

        const ELIGIBILITY_CODE_LABELS = {
            CH: 'General updates',
            CHDATE: 'Date updates',
            CHGEO: 'Geographical updates',
            DW: 'Dynamic waiver',
            PEN: 'Penalty applies',
            UPGRADE: 'Upgrades',
            EA: 'Eligible airlines',
        };

        const ELIGIBILITY_VALUE_LABELS = {
            Y: 'Yes',
            N: 'No',
            R: 'Yes (with restrictions)',
            A: 'ALL',
        };

        return {
            options: {},
            params,
            getFlights,
            checkEligibility,
            checkAgentApiKey,
            fetchFlights,
            getMaxBookDate,
            getLabels,
            getModule,
            resetParams: function() {
                _params[module] = new atcFlightSearchParams(module);
            },
            resetSegmentFilterData,
            loadMoreFlights,
            applyFilters,
            getRules,
        };

        function getFlights() {
            return flights;
        }

        function resetSegmentFilterData() {
            this.params.SegmentFilterData = [];
            this.params.filterByGroup = [];
        }

        function checkEligibility(request, cabinClasses) {
            const parameters = {
                pnr: request.pnr,
                tripId: request.trip,
                departmentId: request.department,
                fromTripDetails: request.fromTripDetails,
                isAgent: request.isAgent,
            };
            return atcApiService
                .checkEligibility(parameters)
                .then(function({data}) {
                    atcFlightsService.proccessResponse(data);

                    _params[module].Pnr = request.pnr;
                    _params[module].DepartmentId = request.department;
                    _params[module].TripId = request.trip;
                    _params[module].FromTripDetails = request.fromTripDetails;
                    _params[module].IsAgent = request.isAgent;
                    if (data.Result) {
                        _params[module].Carriers = data.Result.Carriers;
                        _params[module].prepareTravellersData(
                            data.Result.Travellers
                        );
                        _params[module].prepareFlightsData(
                            data.Result.Segments,
                            cabinClasses
                        );
                        _params[module].ShowBaggageFilter = data.Result.ShowBaggageFilter;
                        _params[module].ShowEligibilityInfo = data.Result.ShowEligibilityInfo;
                        _params[module].ShowEligibilityInfo = data.Result.ShowEligibilityInfo;
                        _params[module].AllowChangeCarrier = data.Result.AllowChangeCarrier;
                        _params[module].FlexibleCondition = data.Result.Segments.length < 3;
                        _params[module].Eligibility = collectEligibilityInfo(data.Result.Eligibility, data.Result.AllCarriers, data.Result.Carriers);
                    }
                });
        }

        function checkAgentApiKey(apikey) {
            return atcApiService.checkAgentApiKey(apikey);
        }


        function fetchFlights(parameters) {
            const request = parameters;
            this.params.resetPagination();

            delete parameters.SearchId;
            delete request.SearchId;

            //update params segment dates
            this.params.TicketSearchSegments.forEach((seg, i) => {
                seg.DepartureDate = request.Segments[i].date;
            });

            return atcApiService
                .searchFlights(request)
                .then(function({data}) {
                        atcFlightsService.proccessResponse(data);
                        flights = data.Result;
                        _flights[module] = data.Result;
                        this.params.SearchId = flights.SearchId;
                        this.params.CacheKey = flights.CacheKey;
                    }.bind(this)
                );
        }

        function getMaxBookDate() {
            return moment().add({months: BOOK_MONTHS_ADVANCE});
        }

        function getRequestCopy(request) {
            const requestCopy = angular.copy(request);
            if (!angular.isString(requestCopy.Filters.FlightNumber) || !requestCopy.Filters.FlightNumber) {
                requestCopy.Filters.FlightNumber = null;
            }
            return requestCopy;
        }

        function applyFilters(filters, comparison) {

            this.params.Filters = filters;
            this.params.resetPagination();

            const request = this.params.getSearchRequestParams();
            // comparisonFilter = comparison;
            // if (comparison) {
            //     request.RequestedRecommendationId = comparison;
            // }
            atcApiService.filter(getRequestCopy(request))
                .then(({data}) => {
                    flights.Recommendations = data.Result.Recommendations;
                    flights.FilteredTotal = data.Result.FilteredTotal;
                    $rootScope.$emit(baseEvents.FLIGHT_FILTER_SEARCH_ENDED);
                    $rootScope.$broadcast(baseEvents.UPDATE_FILTERS, {
                        Filters: data.Result.Filters,
                    });
            });
        }

        function loadMoreFlights() {
            this.params.adjustPaginationParams(flights.FilteredTotal);
            atcApiService.moreFlightResults(getRequestCopy(this.params.getSearchRequestParams()))
                .then((response) => {
                    return flights.Recommendations.push.apply(
                        flights.Recommendations,
                        response.data.Result.Recommendations
                    );
                });
        }

        function getRules(parameters) {
            const isReadOnlyMode = sessionService.getSessionItem('readOnlyMode');

            return atcApiService.getRules(parameters)
                .then(({data}) => {
                    let rules = data.FlightRules;
                    const penalties = _.find(rules, (rule) => rule.Description === 'Penalties');
                    rules = _.filter(rules, (rule) => rule.Description !== 'Penalties');

                    if (penalties) {
                        rules.unshift(penalties);
                    }

                    return {isExist: data.HasTextRules, rules, culture: parameters.culture};
                })
                .then((rulesResponse) => {
                    if (!isReadOnlyMode) {
                        return rulesResponse;
                    }

                    return loginFactory.getLocalization(rulesResponse.culture)
                        .then((localizationResponse) => {
                            l10nService.updateList(localizationResponse);
                            return rulesResponse;
                        });
                });
        }

        function getLabels() {
            return labels;
        }

        function getModule() {
            return module;
        }

        function addUpdateEligibilityInfo(info, item, groupByCodeValue = true) {
            if (groupByCodeValue) {
                const itemToUpdate = info.filter((it) => it.Code === item.Code && it.Value === item.Value)[0];
                if (!itemToUpdate) {
                    info.push(item);
                    return;
                }
                item.Refs.forEach((ref) => {
                    if (itemToUpdate.Refs.indexOf(ref) < 0) {
                        itemToUpdate.Refs.push(ref);
                    }
                });
                return;
            }
            info.push(item);
        }

        function getMappedItem(code, value, refs) {
            return {
                Refs: refs,
                Code: code,
                LabelCode: ELIGIBILITY_CODE_LABELS[code] || code,
                Value: value,
                LabelValue: ELIGIBILITY_VALUE_LABELS[value] || value,
            };
        }

        function getComplementaryText(item, paxRefs, segRefs) {
            const itemSeg = item.Refs.filter((ref) => ref[0] === 'S');
            if (itemSeg.length !== segRefs.length) {
                return `(${itemSeg.map((seg) => `${$filter('ordinal')(segRefs.indexOf(seg) + 1)} ${l10nService.localize('flight')}`).join()})`;
            }
            const itemPax = item.Refs.filter((ref) => ref[0] === 'P');
            if (itemPax.length !== paxRefs.length) {
                return `(${itemPax.map((pax) => `${$filter('ordinal')(paxRefs.indexOf(pax) + 1)} ${l10nService.localize('traveller')}`).join()})`;
            }
            return '';
        }

        function addComplementaryText(results, paxRefs, segRefs) {
            results.forEach((currentItem) => {
                if (results.filter((item) => item.Code === currentItem.Code).length > 1) {
                    currentItem.ComplementaryText = getComplementaryText(currentItem, paxRefs, segRefs);
                }
            });
        }

        function collectEligibilityInfo(eligibility, allCarriers, carriers) {
            if (!eligibility) {
                return [];
            }
            const results = [];
            const segRefs = [];
            const paxRefs = [];
            eligibility.forEach((pax) => {
                const paxRef = 'P' + pax.PaxRef;
                if (pax.GeneralEligibility !== null) {
                    for (const prop in pax.GeneralEligibility) {
                        if (Object.hasOwnProperty.call(pax.GeneralEligibility, prop)) {
                            addUpdateEligibilityInfo(results, getMappedItem(prop, pax.GeneralEligibility[prop], ['G', paxRef]));
                            if (paxRefs.indexOf(paxRef) < 0) {
                                paxRefs.push(paxRef);
                            }
                        }
                    }
                }
                if (pax.CuponEligibility !== null) {
                    pax.CuponEligibility.forEach((seg) => {
                        for (const prop in seg.Eligibility) {
                            if (Object.hasOwnProperty.call(seg.Eligibility, prop)) {
                                const segRef = 'S' + seg.SegmentRef;
                                addUpdateEligibilityInfo(results, getMappedItem(prop, seg.Eligibility[prop], [segRef, paxRef]));
                                if (segRefs.indexOf(segRef) < 0) {
                                    segRefs.push(segRef);
                                }
                            }
                        }
                    });
                }
            });

            if (allCarriers || carriers.length > 0) {
                addUpdateEligibilityInfo(results, getMappedItem('EA', allCarriers ? 'A' : `${carriers.length} airline${(carriers.length === 1 ? '' : 's')}`, ['G']));
            }

            addComplementaryText(results, paxRefs, segRefs);
            return results;
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/services/atcFlightsFactory.js